import { Textarea } from "@mantine/core";
import React from "react";

const TextAreaWrapper = ({
  label,
  id,
  name,
  onChange,
  value,
  placeholder,
  className,
  error,
  onKeyDown,
  ...restProps
}) => {
  return (
    <Textarea
      rows={5}
      className={className || ""}
      label={label}
      error={error ?? null}
      value={value}
      name={name}
      id={id}
      onChange={onChange}
      placeholder={placeholder}
      onKeyDown={onKeyDown}
      minRows={5}
      {...restProps}
    />
  );
};

export default TextAreaWrapper;
